import { call, take, put, fork, all } from 'redux-saga/effects';
import { StaticToast } from 'src/components/common';
import { fetchJson } from 'src/utils/fetch';
import { rasSecretKeyEncrypt ,aesDecrypt} from 'src/utils/tool';
import validate from 'src/utils/validate';
import { AddressActionTypes } from './type';
// import * as Sentry from "@sentry/browser";

function* fetch_address_list() {
  while (true) {
    const action = yield take(AddressActionTypes.FETCH_ADDRESS_LIST);
    try {
      const params={
        sensitiveKeyEncry:rasSecretKeyEncrypt(),
        option: {
          needSensitiveEncrypt: !!validate.isBestpay(),
        },
      };
      const res = yield call(fetchJson, { url: '/api/api/v1/patient/user/deliveryAddress/list', type: 'POST', action, isloading: true,data:params });
      if (res && res.code === '0') {
        const { result = [] } = res;
        const data: any[] = [];
        result.length && result.forEach((element) => {
          const obj = {
            ...element,
            districtCode: element.districtCode && element.districtCode.split('-').map(Number),
          };
          if(params.option.needSensitiveEncrypt){
            obj.contactUserPhone = aesDecrypt(element.contactUserPhone);
            obj.contactUserName = aesDecrypt(element.contactUserName);
            obj.contactUserAddress = aesDecrypt(element.contactUserAddress);
            obj.districtName = aesDecrypt(element.districtName);
          }
          data.push(obj);
        });
        yield put({ type: AddressActionTypes.FETCH_ADDRESS_LIST_SUCCESS, data });
      }
    } catch (error) {
      // Sentry.captureException(error);
      // StaticToast.error('fetch_address_list--------' + error.message);
      StaticToast.error('网络异常，请稍后重试');
    }
  }
}

function* save_address() {
  while (true) {
    const action = yield take(AddressActionTypes.SAVE_ADDRESS);
    try {
      const { options, onSuccess } = action;
      let res: any = {};
      if (options.id) {
        res = yield call(fetchJson, {
          url: '/api/api/v1/patient/user/deliveryAddress/modify', type: 'POST', action, data: {
            ...options,
            contactUserAddress: options.contactUserAddress.trim(),
            districtCode: options.districtCode.join('-'),
            isDefault: options.isDefault === 'Y' ? 'Y' : 'N',
          },
        });
      } else {
        res = yield call(fetchJson, {
          url: '/api/api/v1/patient/user/deliveryAddress/save', type: 'POST', action, data: {
            ...options,
            contactUserAddress: options.contactUserAddress.trim(),
            districtCode: options.districtCode.join('-'),
            isDefault: options.isDefault === 'Y' ? 'Y' : 'N',
          },
        });
      }
      if (res && res.code === '0') {
        typeof onSuccess === 'function' && onSuccess();
        yield put({ type: AddressActionTypes.SAVE_ADDRESS_SUCCESS });
      }
    } catch (error) {
      // Sentry.captureException(error);
      // StaticToast.error('save_address--------' + error.message);
      StaticToast.error('网络异常，请稍后重试');
    }
  }
}


function* delete_address() {
  while (true) {
    const action = yield take(AddressActionTypes.DELETE_ADDRESS);
    try {
      const { id, onSuccess } = action;
      const res = yield call(fetchJson, {
        url: '/api/api/v1/patient/user/deliveryAddress/delete',
        type: 'GET',
        action,
        data: {
          addressId: id,
        },
      });
      if (res && res.code === '0') {
        StaticToast.success('地址删除成功');
        typeof onSuccess === 'function' && onSuccess();
        yield put({ type: AddressActionTypes.FETCH_ADDRESS_LIST });
      }
    } catch (error) {
      // Sentry.captureException(error);
      // StaticToast.error('delete_address--------' + error.message, 60000);
      StaticToast.error('网络异常，请稍后重试');
    }
  }
}

export default function* root() {
  yield all([
    fork(fetch_address_list),
    fork(save_address),
    fork(delete_address),
  ]);
}
